import { useEffect } from "react";

const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Mobile Kitchen Company (UK) Limited",
  url: "https://mobilekitchencompany.co.uk",
  telephone: "+447740051799",
  description:
    "Mobile kitchen hire and temporary kitchen hire across Surrey. Fully equipped temporary kitchen pods delivered to your door during renovations, water damage repairs and building works.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Ground Floor, Egerton House, 68 Baker Street",
    addressLocality: "Weybridge",
    addressRegion: "Surrey",
    postalCode: "KT13 8AL",
    addressCountry: "GB",
  },
  areaServed: "Surrey",
  openingHours: "Mo-Fr 09:00-17:00",
  sameAs: [
    "https://www.facebook.com/mobilekitchencompany",
    "https://www.instagram.com/mobilekitchencompany",
    "https://www.tiktok.com/@mobilekitchencompany",
  ],
};

export default function SEO({ title, description, extraSchema }) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://mobilekitchencompany.uk${window.location.pathname}`);
    if (!document.getElementById("localbusiness-schema")) {
      const script = document.createElement("script");
      script.id = "localbusiness-schema";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(LOCAL_BUSINESS_SCHEMA);
      document.head.appendChild(script);
    }
    document.getElementById("page-schema")?.remove();
    if (extraSchema) {
      const script = document.createElement("script");
      script.id = "page-schema";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(extraSchema);
      document.head.appendChild(script);
    }
  }, [title, description, extraSchema]);
  return null;
}
